// node_modules
import axios from "axios";
// Helpers
import { AxiosHelperSingleton } from "Helpers";
// Types
import { TCopiedQAAnswerDTO } from "Types";


export class LoggingController {
    public async copiedQAAnswerAsync(copiedQAAnswer: TCopiedQAAnswerDTO): Promise<boolean> {
        try {
            const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/logging/copiedqaanswer`,
            copiedQAAnswer);
            return result.status === 200;
        } catch {
            return false;
        }
    }
}

export const LoggingControllerSingleton = new LoggingController(); 